import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var C = (l) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-856 -120)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ t("path", {
      d: "M10 4.47369L17.5 9.99998L10 15.5263L2.5 9.99998L10 4.47369Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M9.99961 13.1578C11.7436 13.1578 13.1574 11.744 13.1574 9.99998C13.1574 8.25596 11.7436 6.84216 9.99961 6.84216C8.2556 6.84216 6.8418 8.25596 6.8418 9.99998C6.8418 11.744 8.2556 13.1578 9.99961 13.1578Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M8.4207 9.80267C7.87156 9.80267 7.3416 9.88619 6.84277 10.0412C6.86484 11.7662 8.26937 13.1579 9.99965 13.1579C11.0696 13.1579 12.0145 12.6254 12.5857 11.8114C11.6084 10.588 10.1046 9.80267 8.4207 9.80267Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ t("path", {
      d: "M13.099 10.605C13.137 10.4091 13.1575 10.207 13.1575 9.99997C13.1575 8.25591 11.7437 6.84204 9.99961 6.84204C8.69828 6.84204 7.58113 7.62938 7.09766 8.75356C7.525 8.66505 7.9675 8.61841 8.42066 8.61841C10.2549 8.61841 11.9141 9.38079 13.099 10.605Z",
      fill: "#0052B4"
    })
  ]
});
export {
  C as default
};
